import { render } from "./App.vue?vue&type=template&id=14cb966d&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=14cb966d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-14cb966d"

export default script